export default "__VITE_ASSET__DTH30ats__"